import { API_ORIGIN } from './api-base.js';

const PATH_LIKE_RE = /^(?:\/|\.?\/|uploads?\/|storage\/|files?\/|pictures?\/|images?\/|printscreen\/)|\.(?:jpe?g|png|gif|webp|bmp|svg)(?:[?#].*)?$/i;

export function normalizeAssetUrl(value: unknown, base = API_ORIGIN): string {
	if (typeof value !== 'string') return '';
	const text = value.trim();
	if (!text) return '';
	if (/^(?:data:image\/|blob:)/i.test(text)) return text;
	if (/^\/\//.test(text)) return `https:${text}`;
	if (/^http:\/\//i.test(text)) return text.replace(/^http:\/\//i, 'https://');
	if (/^https:\/\//i.test(text)) return text;
	if (/^[a-z][a-z0-9+.-]*:/i.test(text)) return '';

	const path = text.replace(/\\/g, '/');
	if (!PATH_LIKE_RE.test(path)) return '';
	const normalizedPath = path.startsWith('/') ? path : `/${path.replace(/^\.?\//, '')}`;
	return base ? `${base}${normalizedPath}` : normalizedPath;
}
